import * as React from 'react'
import { Grid, Form } from 'semantic-ui-react'

import { handleDataChange } from '../../store/survey-data'
import Constants from '../../utils/constants'
import HTMLText from '../system-wide/html-text'
import DebounceInput from './utils/debounce-input'
import { CommentItemField } from './comment-field'

const textFieldStyle = { marginTop: '0.3rem' }
export class TextField extends React.Component {
  static defaultProps = {
    hasComment: false,
  }

  handleChange = e => {
    try {
      this.props.dispatch(
        handleDataChange(this.props.currentPageName, this.props.questionName, this.props.name, e.target.value)
      )
    } catch (e) {
      this.setState(() => {
        throw e
      })
    }
  }

  render() {
    const { labelWidth, inputWidth } = Constants.getDefaultFieldWidths(this.props.questionWidth)
    const textStyle = { opacity: this.props.disabled ? '0.45' : '1' }
    const withToggleStyle = this.props.visible ? {} : { display: 'none' }

    return (
      <React.Fragment>
        {this.props.label && (
          <Grid.Column
            className={`multiple ${this.props.className ?? ''}`}
            {...Constants.getWidths(labelWidth)}
            style={{ ...textFieldStyle, ...withToggleStyle }}>
            <span style={textStyle}>
              <HTMLText value={this.props.label} />
            </span>
            {this.props.hasComment === true && (
              <CommentItemField
                disabled={this.props.disabled}
                visible={this.props.visible}
                currentPageName={this.props.currentPageName}
                questionName={this.props.questionName}
                name={this.props.name + '_comment'}
                jsonref={this.props.jsonref + '_comment'}
              />
            )}
          </Grid.Column>
        )}
        <Grid.Column
          className={`multiple ${this.props.className ?? ''}`}
          {...Constants.getWidths(inputWidth)}
          style={withToggleStyle}>
          <DebounceInput
            debounceTimeout={Constants.DEBOUNCE_TIMEOUT}
            element={Form.Input}
            {...(this.props.hasError ? { error: true } : {})}
            fluid
            name={this.props.name}
            value={this.props.replyValue}
            maxLength={this.props.maxlength || 80}
            disabled={this.props.disabled || this.props.emptyComment === true}
            onChange={this.handleChange}
            style={this.props.hasComment ? { marginTop: '1.35rem' } : {}}
          />
        </Grid.Column>
      </React.Fragment>
    )
  }
}
TextField.displayName = 'TextField'

export default TextField
